import isNil from 'lodash/isNil'
import { useMediaQuery } from 'react-responsive'

type ScreenSizeStyle = {
  small?: boolean
  xsmall?: boolean
}

function useScreenSizeStyle({
  xl,
  lg,
  md,
  sm,
  generic,
}: {
  xl?: ScreenSizeStyle | string
  lg?: ScreenSizeStyle | string
  md?: ScreenSizeStyle | string
  sm?: ScreenSizeStyle | string
  generic?: ScreenSizeStyle | string
}) {
  const isXl = useMediaQuery({ minWidth: 1280 })
  const isLg = useMediaQuery({ minWidth: 1024 })
  const isMd = useMediaQuery({ minWidth: 768 })
  const isSm = useMediaQuery({ minWidth: 640 })

  if (isXl && !isNil(xl)) return xl
  if (isLg && !isNil(lg)) return lg
  if (isMd && !isNil(md)) return md
  if (isSm && !isNil(sm)) return sm
  return generic
}

export default useScreenSizeStyle
